
/**
 * 递归替换掉内部所有json字符串为对象或数组
 * @param {Object} data 
 */
const replaceJson = (data) => {
    if (!data) return data
    if (Array.isArray(data)) {
        for (let index in data) {
            data[index] = replaceJson(data[index]);
        }
    } else {
        Object.keys(data).forEach((key) => {
            if (data[key] && typeof data[key] === "string") {
                try {
                    let obj = JSON.parse(data[key]);
                    data[key] = replaceJson(obj);
                } catch (e) {
                }
            } else {
                data[key] = replaceJson(data[key])
            }
        });
    }
    return data;
};
const checkCellPhone = (rule, value, callback) => {
    console.log('checkcellphone: ', value);
    if (!value) callback(new Error('电话不能为空'));
    if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
    }
    callback();
}

export default {
    replaceJson,
}

export {
    checkCellPhone
}